interface PromotionLite {
  promotionId: number
  isMain?: '0' | '1'
  promotionType?: 'DISCOUNT' | 'EXTRA' | 'SALEPRICE' | string
}

interface ItemLite {
  itemId?: number | string
  operativeId?: number | string
  promotion?: PromotionLite[]
}

export interface PromotionWithLimit {
  promotionId: number
  maxUsagePerVisit?: number | null
  usedCountInCase?: number
  promotionType?: string
}

export function countPromotionUsageInItems(
  items: ItemLite[],
  promotionId: number,
): number {
  return items
    .flatMap(i => i.promotion || [])
    .filter(p =>
      p.promotionId === promotionId &&
      p.isMain === '1' &&
      p.promotionType !== 'EXTRA',
    )
    .length
}

export function isPromotionAtLimit(
  promo: PromotionWithLimit,
  items: ItemLite[],
  excludeItemKey?: number | string,
): boolean {
  if (promo.promotionType === 'EXTRA') return false
  if (promo.maxUsagePerVisit == null) return false

  const filtered = excludeItemKey == null
    ? items
    : items.filter(i => (i.itemId ?? i.operativeId) !== excludeItemKey)
  const count = countPromotionUsageInItems(filtered, promo.promotionId)
  return count >= promo.maxUsagePerVisit
}
